import { render, staticRenderFns } from "./ui-city-suggest.vue?vue&type=template&id=0a113fbf&"
import script from "./ui-city-suggest.vue?vue&type=script&lang=js&"
export * from "./ui-city-suggest.vue?vue&type=script&lang=js&"
import style0 from "./ui-city-suggest.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a113fbf')) {
      api.createRecord('0a113fbf', component.options)
    } else {
      api.reload('0a113fbf', component.options)
    }
    module.hot.accept("./ui-city-suggest.vue?vue&type=template&id=0a113fbf&", function () {
      api.rerender('0a113fbf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/kit/ui-city-suggest/ui-city-suggest.vue"
export default component.exports